<template>
  <div :class="!colaborador.ativado ? 'colaborador-desativado' : ''">
    <div :class="dialog_colaborador.aberto || dialog_bater_ponto.aberto || dialog_justificativa.aberto ? 'blur' : ''">
      <div class="header">
        <div class="avatar mr-sm-3 mb-3">
          <span class="avatar-ini">{{avatar}}</span>
        </div>
        <div class="mb-4">
          <h1>{{colaborador.nome}} {{colaborador.sobrenome}}</h1>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/colaboradores'}">Colaboradores</el-breadcrumb-item>
            <el-breadcrumb-item>{{colaborador.nome}} {{colaborador.sobrenome}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="espaco mobile-none" />

        <div v-if="colaborador.ativado">
          <el-button icon="el-icon-edit" class="botao-cancelar mb-3" @click="dialog_justificativa.aberto = true">
            <span>Justificar Ponto</span>
          </el-button>

          <el-button icon="el-icon-time" class="botao-cancelar mb-3" @click="dialog_bater_ponto.aberto = true">
            <span>Bater Ponto</span>
          </el-button>

          <el-button icon="el-icon-setting" class="botao mb-3" @click="dialog_colaborador.aberto = true">
            <span>Editar Colaborador</span>
          </el-button>
        </div>
      </div>

      <div v-if="!colaborador.ativado" class="mb-5">
        <el-alert title="Esse colaborador está desativado" type="info" center show-icon :closable="false"></el-alert>
      </div>

      <el-row :gutter="30" class="historico">
        <el-col :xs="24" :sm="12">
          <HistoricoDiario />
        </el-col>

        <el-col :xs="24" :sm="12">
          <HistoricoMensal :horasSemana="parseInt(colaborador.horasSemana)" />
        </el-col>
      </el-row>
    </div>

    <!-- Dialog editar colaborador -->
    <DialogColaborador v-if="dialog_colaborador.aberto" :abrirDialog="dialog_colaborador" :colaboradorSelecionado="colaborador" :editar="true" />

    <!-- Dialog bater ponto -->
    <DialogBaterPonto v-if="dialog_bater_ponto.aberto" :abrirDialog="dialog_bater_ponto" />

    <!-- Dialog justificativa -->
    <DialogJustificativa v-if="dialog_justificativa.aberto" :abrirDialog="dialog_justificativa" />
  </div>
</template>

<script>
import DialogColaborador from './dialog-colaborador.vue';
import DialogBaterPonto from './dialog-bater-ponto.vue';
import DialogJustificativa from './dialog-justificativa.vue';
import HistoricoDiario from './historico-diario.vue';
import HistoricoMensal from './historico-mensal.vue';

export default {
  components: {
    DialogColaborador, DialogBaterPonto, DialogJustificativa, HistoricoDiario, HistoricoMensal
  },
  data: () => ({
    dialog_colaborador: { aberto: false },
    dialog_bater_ponto: { aberto: false },
    dialog_justificativa: { aberto: false },
    editar_ponto: false,
    colaborador: {}
  }),
  created() {
    const refColaborador = this.$db.ref(`colaboradores/${this.$route.params.user}`);

    refColaborador.once('value', colab => {
      this.colaborador = colab.val();
    });
  },
  computed: {
    avatar() {
      return (this.colaborador.nome || '').charAt(0);
    }
  }
};
</script>

<style lang="scss" scoped>
.horas {
  background: #1a1b29;
  padding: 10px 25px;
  text-align: center;
  border-radius: 50px;
  margin-top: 0;
  font-size: 14px;

  &:before {
    display: inline-block;
    content: " ";
    width: 10px;
    height: 10px;
    background: rgba(#ffffff, .2);
    margin-right: 10px;
    border-radius: 50%;
  }

  &.extra {
    &:before {
      background: #43e695;
    }
  }

  &.falta {
    &:before {
      background: #f56c6c;
    }
  }
}

.historico {
  text-align: center;

  > div {
    flex-grow: 1;
    flex-basis: 0;
    margin-bottom: 30px;
  }
}

.colaborador-desativado {
  .avatar {
    background: #888 !important;
  }

  .el-alert {
    background-color: #1a1b29;
  }
}
</style>
